import { Component, inject, Input, input } from "@angular/core";
import { ControlContainer, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { FormFieldComponent } from "@odx/angular/components/form-field";

@Component({
  selector: "app-forza-id-form-field",
  imports: [FormFieldComponent, UiKitModule, ReactiveFormsModule],
  templateUrl: "./forza-id-form-field.component.html",
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (): ControlContainer => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  standalone: true,
})
export class ForzaIdFormFieldComponent {
  @Input() isReadonly!: boolean;
  @Input() required!: boolean;
  isWriteable = input(false);
}
